function convertLegacySelect2Matcher(matcher) {
  function wrappedMatcher (params, data) {
    var match = $.extend(true, {}, data);

    if (params.term == null || $.trim(params.term) === '') {
      return match;
    }

    if (data.children) {
      for (var c = data.children.length - 1; c >= 0; c--) {
        var child = data.children[c];

        // Check if the child object matches
        // The old matcher returned a boolean true or false
        var doesMatch = matcher(params.term, child.text, child);

        // If the child didn't match, pop it off
        if (!doesMatch) {
          match.children.splice(c, 1);
        }
      }

      if (match.children.length > 0) {
        return match;
      }
    }

    if (matcher(params.term, data.text, data)) {
      return match;
    }

    return null;
  }

  return wrappedMatcher;
}


function matcher(query, text, data) {
  let searchText = `${data.text} ${data.title}`.toUpperCase().trim()
  let words = query.toUpperCase().split(' ')

  return words.every((word) => { return searchText.includes(word) })
}

up.$compiler('select', ($element, customizations) => {

  let defaultOptions = {
    theme: 'bootstrap',
    language: 'de',
    minimumResultsForSearch: 2,
    disabled: $element.is('[disabled]') || $element.closest('[no-edit]').length > 0,
    placeholder: $element.attr('placeholder'),
    matcher: convertLegacySelect2Matcher(matcher),
    width: '100%', // Disables select2's width calculation
    tags: false
  }

  if (up.layer.isOverlay()) {
    // This is necessary if the select is in inside a Unpoly overlay, otherwise the dropdown/search is not interactable.
    defaultOptions.dropdownParent = $('up-modal')
  }

  let options = Object.assign({}, defaultOptions, customizations)

  $element.select2(options)

  // Select2 does not emit native events but jQuery events.
  // https://github.com/select2/select2/issues/4686
  // https://github.com/select2/select2/issues/1908
  $element.enableNativeEvent('change')


  // Select2 controls might overflow inside flexbox containers. To force them to compute their width,
  // we set `overflow-x`. Because of reasons, this has to be set as a `style` tag and not from CSS files.
  $element.data('select2').$container.css('overflow-x', 'hidden')

  // Focus the element after picking a choice, so the user can tab to the next field
  $element.on('select2:close', () => { $element.focus() })
  $element.on('select2:open', () => {
    $('.select2-search__field').attr('placeholder', $element.attr('searchInputPlaceholder'))
  })

  // Prevent the choices to re-open after removing a selection from a multiple select.
  // See a million Github issues and in particular https://github.com/select2/select2/issues/3209#issuecomment-149663474
  $element.on("select2:unselect", function (evt) {
    let originalEvent = evt.params.originalEvent;
    if (originalEvent) {
      originalEvent.stopPropagation();
    }
  });

  // Clean up when the element gets removed from the DOM.
  return () => {
    if ( $element.data('select2') ) {
      $element.select2('destroy')
    }
  }

})
